import React from 'react';
import PropTypes from "prop-types";

import LocationLinkTitle
  from 'components/dashboard/location-links-content/LocationLinkTitle';
import CommonLinkDeleteButton
  from 'components/common/link-elements/CommonLinkDeleteButton';
import LocationLinkIsPublished
  from 'components/dashboard/location-links-content/LocationLinkIsPublished';

import './LocationLinkItemHeaderContent.css';


function LocationLinkItemHeaderContent(props) {
  const { item, deleteLocationLink } = props;

  return (
    <div className="location-link-item-header-content__component">
       <div className="title">
         <LocationLinkTitle linkItem={item} />
       </div>
       <div className="delete">
         <CommonLinkDeleteButton
          key={`location-link-delete-icon-key-${item.id}`}
          linkItem={item}
          deleteFunction={deleteLocationLink}
        />
      </div>
      <div className="is-published">
        <LocationLinkIsPublished linkItem={item} />
      </div>
    </div>
  );
}

LocationLinkItemHeaderContent.propTypes = {
  deleteLocationLink: PropTypes.func.isRequired,
  item: PropTypes.object.isRequired,
};

export default LocationLinkItemHeaderContent;
